var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('majorShowFirst',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPage),expression:"showPage"}],ref:"firstChild",attrs:{"parentMsg":_vm.msg},on:{"childCLick":function($event){return _vm.parentShow()}}}),(!_vm.showPage)?_c('majorAdd',{on:{"chooseOnAdd":_vm.paentChoose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }